<div class="code-input" (click)="onFocus()">
    <input Number *ngFor="let caracter of [].constructor(length);let i = index" name='code' (input)="onCaracterInput($event,i)" [disabled]="disabled" autocomplete="off" #input />
</div>